<app-crudbar
  [label]="title"
  (onReady)="doComReady($event, 'crudbar')"
  [editAndSaveVisible]="true"
>
</app-crudbar>
<div>
  <div class="w-full top-10 border-2 bg-gray-100">
    @if (masterVisible) {
      <div class="top-1 border">
        <app-mtrki02
          (onFormReady)="doFormReady($event, PageKind.master)"
          (detailVisibleChange)="detailVisible = $event"
        >
        </app-mtrki02>
      </div>
    }
    @if (detailVisible) {
      <div class="top-1 border border-green-400">
        <app-mtrki02-detail
          (onFormReady)="doFormReady($event, PageKind.detail)"
        >
        </app-mtrki02-detail>
      </div>
    }
  </div>
  <div></div>
</div>
